module.exports = __webpack_public_path__ + "static/media/twitch.1d5b406f.svg";